import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetAgentDealController = async (agentId) => {
  /** New Code */
  /**
   * input: null
   * output: agent deal document / collection
   * description: get agent deal / get documents
   */

  try {
    const dealsCollection = collection(db, "deals");
    const q = query(dealsCollection, where("agent.id", "==", agentId));
    const dealSnapshot = await getDocs(q);
    const dealsData = [];
    dealSnapshot.forEach((deal) =>
      dealsData.push({ id: deal.id, ...deal.data() })
    );
    return dealsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentDealController;
